export default "/score_num.png";